var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Datepicker',{attrs:{"value":_vm.value,"disabled-dates":_vm.datePickerRange,"format":"yyyy-MM-d","wrapper-class":"pt-0 visnet-events__datepicker","input-class":"datepicker__input"},on:{"input":_vm.changeDate}})}
var staticRenderFns = []

export { render, staticRenderFns }